import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Proof() {
  return <section className="bg-white py-24" data-id="element-133">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative bg-gray-50 rounded-3xl p-8 sm:p-12 md:p-16 border border-gray-200 shadow-xl overflow-hidden" data-id="element-135">
          <div className="absolute top-0 left-0 w-3 h-full bg-brand-yellow" data-id="element-136"></div>
          <Quote className="absolute top-8 right-8 w-24 h-24 text-gray-200 -rotate-12" data-id="element-137" />

          <div className="relative z-10" data-id="element-138">
            <h2 className="text-sm font-bold tracking-widest text-gray-500 uppercase mb-8" data-id="element-139">
              The Result
            </h2>

            <p className="text-2xl sm:text-3xl md:text-4xl font-medium text-brand-dark leading-tight mb-8" data-id="element-140">
              Within 7 days of using the Protocol, your{' '}
              <span className="bg-brand-yellow/30 px-2" data-id="element-141">
                "turnover anxiety"
              </span>{' '}
              will disappear.
            </p>

            <p className="text-xl sm:text-2xl text-gray-600 leading-relaxed" data-id="element-142">
              Instead of frantic scrubbing, you'll be sitting in your car with
              20 minutes to spare, knowing the property is ready for even the
              pickiest guest.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}